// extracted by mini-css-extract-plugin
module.exports = {"progressBox":"styles_progressBox__3jDMP","loadingIcon":"styles_loadingIcon__3B7OD"};